module.exports = __webpack_public_path__ + "static/media/ride.5f5e0077.svg";